<div id="assertionModalDialog" class="modal fade" role="dialog" aria-labelledby="assertionModalDialog"
  aria-hidden="true">
  <div class="e-modal-dialog e-modal-dialog-centered" role="document" cdkDrag cdkDragBoundary=".modal">
    <div [className]="isMinimizeState ? 'e-modal-content' : 'e-modal-content e-modal-content-maximize'">
      <div class="e-modal-header" cdkDragHandle>
        <h1 class="e-modal-title" [matTooltip]="dialogTitle" matTooltipClass="e-tooltip e-tab-tooltip">
          {{ dialogTitle }}
        </h1>
        <button type="button" class="e-maximize" (click)="this.restoreState()">
          @if (isMinimizeState) {
          <span class="fal fa-square" title="maximize"></span>
          }
          @if (!isMinimizeState) {
          <span class="fal fa-window-restore" title="minimize"></span>
          }
        </button>
        <button type="button" class="e-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
          <span class="fal fa-times" title="Close"></span>
        </button>
      </div>
      <div class="e-modal-body">
        <form class="assertion-form" [formGroup]="form">
          <div class="e-filter-contents">
            <div class="e-assertion-form-container">

              <div class="form-row">
                <div class="form-col">
                  <label class="form-label" for="researchProject">ProjectCode:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" formControlName="projectCode"
                    [title]="getTooltip('projectCode')" readonly />
                  } @else {
                  <ng-select #select [items]="currentResearchProjects" [clearable]="false" bindLabel="name"
                    bindValue="code" [searchable]="false" groupBy="status" [searchFn]="searchText"
                    labelForId="researchProject" placeholder="Select Project" formControlName="projectCode"
                    class="e-project-code-select">
                    <ng-template ng-header-tmp>
                      <input #filterInput autofocus placeholder="Search" type="text"
                        (input)="select.filter($event.target.value)" />
                      @if (filterInput.value.length !== 0) {
                      <i (click)="select.filter(''); filterInput.value = ''">X</i>
                      }
                    </ng-template>
                  </ng-select>
                  }
                  @if (form.get('projectCode')?.touched && form.get('projectCode')?.errors) {
                  <div class="form-error">
                    @if (form.get('projectCode')?.errors?.['required']) {
                    <span>ProjectCode is required</span>
                    }
                  </div>
                  }
                </div>
                <div class="form-col">
                  <label class="form-label" for="dataTypeSelect">Data Type:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="getDataTypeLabel()" readonly
                    [title]="getTooltip('dataType')" />
                  } @else {
                  <ng-select #dataTypeSelect [items]="dataTypes" [clearable]="false" bindLabel="name" bindValue="id"
                    [searchable]="false" labelForId="dataTypeSelect" placeholder="Select Data Type"
                    formControlName="dataType" [disabled]="!form.get('projectCode')?.value" class="e-data-type-select"
                    [title]="getDataTypeLabel()">
                    <ng-template ng-header-tmp>
                      <input #dataTypeFilterInput autofocus placeholder="Search" type="text"
                        (input)="dataTypeSelect.filter($event.target.value)" />
                      @if (dataTypeFilterInput.value.length !== 0) {
                      <i (click)="dataTypeSelect.filter(''); dataTypeFilterInput.value = ''">X</i>
                      }
                    </ng-template>
                  </ng-select>
                  }
                  @if (form.get('dataType')?.touched && form.get('dataType')?.errors) {
                  <div class="form-error">
                    @if (form.get('dataType')?.errors?.['required']) {
                    <span>Data Type is required</span>
                    }
                  </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <label class="form-label" for="claimShareTypeSelect">Claim Share Type:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="getShareTypeLabel()" readonly
                    [title]="getTooltip('claimShareType')" />
                  } @else {
                  <mat-select id="claimShareTypeSelect" formControlName="claimShareType"
                    [title]="getTooltip('claimShareType')" class="form-input" placeholder="Select Claim Share Type"
                    panelClass="e-claim-share-type-panel" [disabled]="!form.get('projectCode')?.value">
                    @for (option of shareTypeOptions; track option.id) {
                    <mat-option [value]="option.id">
                      {{ option.label }}
                    </mat-option>
                    }
                  </mat-select>
                  }
                  @if (form.get('claimShareType')?.touched && form.get('claimShareType')?.errors) {
                  <div class="form-error">
                    @if (form.get('claimShareType')?.errors?.['required']) {
                    <span>Claim ShareType is required</span>
                    }
                  </div>
                  }
                </div>

                <div class="form-col">
                  <label class="form-label" for="companyTypeSelect">Company Type:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="getCompanyTypeLabel()" readonly
                    [title]="getTooltip('companyType')" />
                  } @else {
                  <mat-select id="companyTypeSelect" formControlName="companyType" class="form-input"
                    placeholder="Select Company Type" panelClass="e-company-type-panel"
                    [title]="getTooltip('companyType')">
                    @for (companyType of companyTypes; track companyType.id) {
                    <mat-option [value]="companyType.id">
                      {{ companyType.name }}
                    </mat-option>
                    }
                  </mat-select>
                  }

                  @if (form.get('companyType')?.touched && form.get('companyType')?.errors) {
                  <div class="form-error">
                    @if (form.get('companyType')?.errors?.['required']) {
                    <span>Company Type is required</span>
                    }
                  </div>
                  }
                </div>
              </div>

              <div class="form-row">
                <div class="form-col">
                  <label class="form-label">Geography:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="getGeographyLabel()" readonly
                    [title]="getGeographyLabel()" />
                  } @else {
                  <mat-form-field
                    [class]="form.get('geography')?.disabled ? 'geography-select-field disabled-field' : 'geography-select-field'"
                    floatLabel="auto" hideRequiredMarker="true">
                    <mat-label>{{ getGeographyLabel() }}</mat-label>
                    <mat-select formControlName="geography" #geographyselect name="geography"
                      [panelClass]="'e-panel-class'" (opened)="onSelectOpened()">
                      <mat-option style="display: none"> </mat-option>
                      <emma-tree-view #geographyTree [dialogTreeData]="geographies" [treeOptions]="treeOptions"
                        [treeType]="'geography'" [parentComponent]="componentName" [selectedNode]="selectedGeography"
                        (selectedItemEvent)="setGeography($event)" (closeEvent)="closeMatSelect()" />
                    </mat-select>
                  </mat-form-field>
                  }
                  @if (form.get('geography')?.touched && form.get('geography')?.errors) {
                  <div class="form-error">
                    @if (form.get('geography')?.errors?.['required']) {
                    <span>Geography is required</span>
                    }
                  </div>
                  }
                </div>

                <div class="form-col">
                  <label class="form-label" for="claimCalculationSelect">
                    Claim Calculation:
                  </label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="getClaimCalculationLabel()" readonly
                    [title]="getTooltip('claimCalculation')" />
                  } @else {
                  <mat-select id="claimCalculationSelect" formControlName="claimCalculation" class="form-input"
                    placeholder="Select Claim Calculation" panelClass="e-claim-calculation-panel"
                    [title]="getTooltip('claimCalculation')" [disabled]="!form.get('projectCode')?.value">
                    @for (claimCalculation of claimCalculationOptions; track claimCalculation.id) {
                    <mat-option [value]="claimCalculation.id">
                      {{ claimCalculation.label }}
                    </mat-option>
                    }
                  </mat-select>
                  }
                </div>
              </div>

              <div class="form-row">
                <div class="form-col">
                  <label class="form-label">Category:*</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" [value]="productSelectorLabel" readonly
                    [title]="productSelectorLabel" />
                  } @else {
                  <mat-form-field
                    [class]="form.get('product')?.disabled ? 'geography-select-field disabled-field' : 'geography-select-field'"
                    floatLabel="auto" hideRequiredMarker="true">
                    <mat-label>{{ productSelectorLabel }}</mat-label>
                    <mat-select formControlName="product" #productselect name="product" [panelClass]="'e-panel-class'"
                      (opened)="onProductSelectorOpened()" (closed)="onSelectClosed()"
                      (openedChange)="onProductSelectorOpenedChange($event)" multiple>
                      <mat-option style="display: none"></mat-option>
                      <emma-tree-view #productTree [dialogTreeData]="products" [parentComponent]="'componentName'"
                        [treeType]="'product'" [treeOptions]="treeOptions" (closeEvent)="closeMatSelect()"
                        (selectedItemEvent)="onTreeSelectedItemChange($event)" [selectedNode]="selectedProduct" />
                    </mat-select>
                  </mat-form-field>
                  }
                  @if (form.get('product')?.touched && form.get('product')?.errors) {
                  <div class="form-error">
                    @if (form.get('product')?.errors?.['required']) {
                    <span>Product is required</span>
                    }
                  </div>
                  }
                </div>

                <div class="form-col">
                  <label class="form-label">Claim Rank:</label>
                  <input class="form-input" type="text" formControlName="claimRank" inputmode="numeric" pattern="[0-9]*"
                    (input)="onClaimRankInput($event)" [title]="getTooltip('claimRank')" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-col">
                  <label class="form-label">
                    Company:
                    <span class="info-icon" matTooltip="Suggestion based on CRM Account ID.&#10;Click here to change"
                      matTooltipPosition="right" matTooltipClass="e-company-tooltip">
                      ⓘ
                    </span>
                  </label>
                  <input class="form-input" type="text" formControlName="company" [title]="getCompanyTooltip()"
                    (click)="onCompanyFieldClick()" />
                  @if (form.get('company')?.touched && form.get('company')?.errors) {
                  <div class="form-error">
                    @if (form.get('company')?.errors?.['required']) {
                    <span>Company information is required to save the assertion.</span>
                    }
                  </div>
                  }
                </div>

                <div class="form-col">
                  <label class="form-label">Claim Year:</label>
                  @if (isViewMode) {
                  <input class="form-input" type="text" formControlName="claimYear" readonly
                    [title]="getTooltip('claimYear')" />
                  } @else {
                  <mat-select formControlName="claimYear" class="form-input" placeholder="Select Claim Year"
                    panelClass="e-claim-year-panel" [title]="getTooltip('claimYear')">

                    @for (year of claimYearOptions; track year) {
                    <mat-option [value]="year">
                      {{ year }}
                    </mat-option>
                    }
                  </mat-select>
                  }
                </div>
              </div>
              <div class="form-row top-align">
                <div class="form-col">
                  <label class="form-label">Brand:</label>
                  <input class="form-input" type="text" formControlName="brand" [title]="getBrandTooltip()"
                    (click)="onBrandFieldClick()" />
                  @if (form.get('brand')?.touched && form.get('brand')?.errors) {
                  <div class="form-error">
                    @if (form.get('brand')?.errors?.['required']) {
                    <span>Brand information is required to save the assertion.</span>
                    }
                  </div>
                  }
                </div>

                <div class="form-col top-align">
                  <label class="form-label e-note-label">Note:</label>
                  <textarea class="form-input e-note-textarea" formControlName="notes" [title]="getTooltip('notes')" rows="3"></textarea>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
      <div class="e-modal-footer">
       <div class="e-footer-left">
       @if (geographiesError()) {
          <div>
            {{ geographiesError() }}
          </div>
        }
      </div>
        <div class="e-buttons-footer">
          <button type="button" class="e-dialog-button e-cancel-dialog-button e-button-secondary"
            (click)="onCancel()">{{ isViewMode ?
            'CLOSE' : 'CANCEL' }}</button>
          @if (!isViewMode) {
          <button type="button" class="e-dialog-button" (click)="onSave()" [disabled]="isSaveDisabled">
            SAVE
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>